var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"flex underline hover:no-underline text-gray-500 p-0",on:{"click":_vm.backToSearchResults}},[_vm._v(" Terug naar zoekresultaten ")])])}
var staticRenderFns = []

export { render, staticRenderFns }